// extracted by mini-css-extract-plugin
module.exports = {"dob":"dob_dob__dwyKs","day":"dob_day__2y2KB","month":"dob_month__3bxVE","year":"dob_year__2FJz4"};